<template>
    <svg height="13.624" viewBox="0 0 19.463 13.624" width="19.463" xmlns="http://www.w3.org/2000/svg">
        <path
            id="Icon_material-keyboard"
            d="M20.516,7.5H4.946A1.944,1.944,0,0,0,3.01,9.446L3,19.177a1.952,1.952,0,0,0,1.946,1.946h15.57a1.952,1.952,0,0,0,1.946-1.946V9.446A1.952,1.952,0,0,0,20.516,7.5Zm-8.758,2.919H13.7v1.946H11.758Zm0,2.919H13.7v1.946H11.758ZM8.839,10.419h1.946v1.946H8.839Zm0,2.919h1.946v1.946H8.839Zm-.973,1.946H5.919V13.339H7.866Zm0-2.919H5.919V10.419H7.866Zm8.758,6.812H8.839V17.231h7.785Zm0-3.892H14.677V13.339h1.946Zm0-2.919H14.677V10.419h1.946Zm2.919,2.919H17.6V13.339h1.946Zm0-2.919H17.6V10.419h1.946Z"
            data-name="Icon material-keyboard"
            fill="#afafaf"
            transform="translate(-3 -7.5)"
        />
    </svg>
</template>

<script>
export default {
    name: "Keyboard",
};
</script>
